interface MoneyProps {
  money: number | string
  className: string
  iconClass?: string
  testId?: TestId
  sign?: string
  customFont?: string
}

const Money: React.FC<MoneyProps> = ({
  className,
  money,
  iconClass = "",
  testId,
  sign = "",
  customFont = "",
}) => {
  return (
    <span
      className={` grid grid-cols-[min-content_min-content_auto] items-center  ${className}`}
      data-testid={testId}
    >
      {sign}
      <span className={` ${customFont || "font-fira-sans font-normal "}`}>
        M
      </span>
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        className={iconClass}
        viewBox="0 0 288.000000 249.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,249.000000) scale(0.100000,-0.100000)"
          fill="currentColor"
          stroke="none"
        >
          <path d="M660 2437 c0 -11 -200 -1001 -205 -1014 -3 -9 -50 -13 -167 -15 l-163 -3 -11 -50 c-6 -27 -14 -69 -17 -92 l-7 -43 160 0 c182 0 170 7 148 -89 l-11 -51 -161 -2 -161 -3 -11 -55 c-6 -30 -13 -72 -17 -93 l-6 -37 155 0 c133 0 154 -2 154 -16 0 -8 -34 -184 -76 -391 -41 -206 -73 -377 -70 -380 6 -7 195 -27 200 -22 2 2 37 185 77 407 l73 402 275 -2 276 -3 172 -410 c95 -225 177 -413 181 -417 5 -5 87 181 182 412 l173 420 265 -2 266 -3 80 -397 c45 -218 84 -399 87 -403 5 -5 189 13 196 19 1 1 -2 21 -7 46 -47 231 -140 717 -140 727 0 9 37 13 153 15 145 3 152 4 150 23 -1 11 -7 53 -13 92 l-12 73 -161 2 -161 3 -11 63 c-7 34 -9 64 -7 67 3 3 75 5 160 5 l155 0 -7 30 c-3 17 -11 59 -18 95 l-11 65 -162 0 -161 0 -98 498 c-55 273 -102 505 -105 515 -5 12 -79 -156 -221 -498 l-213 -515 -355 2 -355 3 -52 125 c-342 820 -385 920 -385 897z m1531 -779 c16 -73 32 -152 35 -175 l7 -43 -112 0 c-62 0 -111 4 -109 9 34 92 143 349 146 346 3 -2 17 -64 33 -137z m-1478 105 c-2 -20 -1 -23 4 -11 6 13 27 -26 80 -147 l71 -165 -114 0 c-63 0 -114 3 -114 8 0 4 39 6 87 5 94 -2 94 2 1 12 -54 6 -58 8 -59 33 0 25 -1 25 -10 7 -9 -20 -9 -20 -6 0 2 12 15 80 28 153 13 73 26 132 30 132 3 0 5 -12 2 -27z m267 -579 c17 -36 30 -68 30 -70 0 -2 -97 -4 -216 -4 -200 0 -215 1 -210 18 2 9 7 33 11 52 14 76 -2 70 186 70 l170 0 29 -66z m740 59 c0 -5 -12 -36 -26 -70 l-27 -63 -213 0 -213 0 -21 47 c-11 26 -23 57 -26 70 l-6 23 266 0 c146 0 266 -3 266 -7z m554 -9 c3 -9 9 -40 12 -70 l7 -54 -207 0 c-113 0 -206 2 -206 3 0 7 39 118 45 127 4 6 75 10 175 10 144 0 169 -2 174 -16z m-698 -331 c-26 -70 -122 -283 -127 -283 -7 0 -119 273 -119 290 0 6 49 10 126 10 116 0 126 -1 120 -17z" />
        </g>
      </svg> */}
      {money}
    </span>
  )
}

export default Money
